import { defineComponent as v, openBlock as f, createBlock as d, resolveDynamicComponent as _, withCtx as m, renderSlot as p, ref as w, onMounted as k, onBeforeUnmount as y, createElementBlock as O } from "vue";
const l = /* @__PURE__ */ new WeakMap();
function z(e) {
  return typeof e == "function" ? {
    callback: e,
    observer: null,
    intersection: void 0,
    visible: null
  } : {
    callback: e.callback,
    observer: null,
    intersection: e.intersection,
    visible: null
  };
}
function u(e, t) {
  b(e);
  const n = z(t.value);
  if (l.set(e, n), typeof IntersectionObserver > "u") {
    const i = e.getBoundingClientRect();
    n.visible = !0, n.callback(!0, {
      boundingClientRect: i
    });
    return;
  }
  n.observer = new IntersectionObserver((i) => {
    const r = i[0], s = !!(r != null && r.isIntersecting);
    n.visible !== null && n.visible === s || (n.visible = s, n.callback(s, r));
  }, n.intersection), n.observer.observe(e);
}
function b(e) {
  const t = l.get(e);
  t != null && t.observer && (t.observer.disconnect(), t.observer = null);
}
const B = {
  mounted(e, t) {
    u(e, t);
  },
  updated(e, t) {
    t.value !== t.oldValue && u(e, t);
  },
  unmounted(e) {
    b(e), l.delete(e);
  }
}, C = /* @__PURE__ */ v({
  __name: "ItemView",
  props: {
    view: {},
    itemTag: {}
  },
  setup(e) {
    const t = e;
    return (n, i) => (f(), d(_(t.itemTag), { class: "vue-recycle-scroller__item-view" }, {
      default: m(() => [
        p(n.$slots, "default", {
          item: t.view.item,
          index: t.view.nr.index,
          active: t.view.nr.used
        })
      ]),
      _: 3
    }));
  }
}), g = /* @__PURE__ */ v({
  __name: "ResizeObserver",
  emits: ["notify"],
  setup(e, { emit: t }) {
    const n = t, i = w();
    let r = null, s = null;
    function a() {
      n("notify");
    }
    return k(() => {
      var c;
      const o = (c = i.value) == null ? void 0 : c.parentElement;
      if (o) {
        if (typeof ResizeObserver < "u") {
          r = new ResizeObserver(() => {
            a();
          }), r.observe(o);
          return;
        }
        s = () => a(), window.addEventListener("resize", s);
      }
    }), y(() => {
      r && (r.disconnect(), r = null), s && (window.removeEventListener("resize", s), s = null);
    }), (o, c) => (f(), O("div", {
      ref_key: "el",
      ref: i,
      class: "vue-recycle-scroller__resize-observer",
      "aria-hidden": "true"
    }, null, 512));
  }
}), R = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, r] of t)
    n[i] = r;
  return n;
}, I = /* @__PURE__ */ R(g, [["__scopeId", "data-v-08cc04ab"]]);
export {
  B as O,
  I as R,
  C as _
};
//# sourceMappingURL=scroller.css_vue_type_style_index_0_src_true_lang--7gJ3zh_.js.map
